import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import { type IMPORTANT_NOTIFICATION, UserEnrollmentPage } from '../-Page';
import { EndedUserEnrollmentPage } from '../-Page/endedUserEnrollment';

export const USER_ENROLLMENT_FOR_CONTAINER = graphql(/* GraphQL */ `
  fragment UserEnrollmentForContainer on UserEnrollment {
    scheduleStatus
    ...UserEnrollment
    ...EndedUserEnrollment
  }
`);

export type UserEnrollmentContainerProps = {
  currentEmbaUserEnrollment: FragmentType<typeof USER_ENROLLMENT_FOR_CONTAINER>;
  importantNotification: FragmentType<typeof IMPORTANT_NOTIFICATION> | null;
};

export const UserEnrollmentContainer = ({
  currentEmbaUserEnrollment,
  importantNotification,
}: UserEnrollmentContainerProps) => {
  const embaUserEnrollmentCoursesData = useFragment(
    USER_ENROLLMENT_FOR_CONTAINER,
    currentEmbaUserEnrollment,
  );

  if (embaUserEnrollmentCoursesData.scheduleStatus === 'ended') {
    return (
      <EndedUserEnrollmentPage
        currentEmbaUserEnrollment={embaUserEnrollmentCoursesData}
        importantNotification={importantNotification}
      />
    );
  }

  return (
    <UserEnrollmentPage
      currentEmbaUserEnrollment={embaUserEnrollmentCoursesData}
      importantNotification={importantNotification}
    />
  );
};
